const productsData = [
    { title: 'VelociRax 3x', tags: '3', img: 'https://cdn.shopify.com/s/files/1/0673/7883/9862/products/3rack_FinalColorOutput0000.png?v=1694464253', href: "https://www.velocirax.com/products/velocirax-3x" },
    { title: 'VelociRax 412', tags: '4', img: 'https://cdn.shopify.com/s/files/1/0673/7883/9862/products/4rack_FinalColorOutput0000_13e58e5c-efaf-48c9-b5b0-8fefe3b68f8d.png?v=1694464362', href: "https://www.velocirax.com/products/velocirax-412" },
    { title: 'VelociRax 5', tags: '5', img: 'https://cdn.shopify.com/s/files/1/0673/7883/9862/products/5rack_FinalColorOutput0000_33c8d86f-58ef-4bbd-a5fa-7a55d1f6eea1.png?v=1694464282', href: "https://www.velocirax.com/products/velocirax-5" },
    { title: 'VelociRax 5x', tags: '8', img: 'https://cdn.shopify.com/s/files/1/0673/7883/9862/products/5widerack_FinalColorOutput0000_7c84ceda-8eb9-46e3-bea6-ce4cf2c56e0b.png?v=1694464304', href: "https://www.velocirax.com/products/velocirax-5x" },
    { title: 'VelociRax 6', tags: '6', img: 'https://cdn.shopify.com/s/files/1/0673/7883/9862/products/6rack_FinalColorOutput0000_ad545276-59a3-4e54-98b9-95afe75330a6.png?v=1694464333', href: "https://www.velocirax.com/products/velocirax-6" },
    { title: 'VelociRax 7', tags: '7', img: 'https://cdn.shopify.com/s/files/1/0673/7883/9862/products/7rack_FinalColorOutput0000_d4c0f083-3dd1-4cd1-a1cd-2e519cde42a4.png?v=1694464358', href: "https://www.velocirax.com/products/velocirax-7" },
];

const bikeTypesEnum = Object.freeze({
    MOUNTAIN: 'mtb',
    ROAD: 'road',
    ELECTRIC: 'elec',
    FAT: 'fat',
    YOUTH: 'child',
});

const rackType = Object.freeze({
    EIGHT: { tags: 8, maxNumBikes: 5, mtb: 5, elec: 4, child: 5, fat: 5, road: 5, roadNormal: 5 },
    SEVEN: { tags: 7, maxNumBikes: 7, mtb: 7, elec: 4, child: 7, fat: 4, road: 7, roadNormal: 4 },
    SIX: { tags: 6, maxNumBikes: 6, mtb: 6, elec: 4, child: 6, fat: 4, road: 6, roadNormal: 3 },
    FIVE: { tags: 5, maxNumBikes: 5, mtb: 5, elec: 4, child: 5, fat: 3, road: 5, roadNormal: 3 },
    FOUR: { tags: 4, maxNumBikes: 4, mtb: 4, elec: 4, child: 4, fat: 4, road: 4, roadNormal: 2 },
    THREE: { tags: 3, maxNumBikes: 3, mtb: 3, elec: 3, child: 3, fat: 3, road: 3, roadNormal: 3 },
  });

let previousButton = null;
let prevButtonNum = 0;
let button7, button6, button5, button4, button3, button2, button1, vehicleTypeMessage, bikeValue, roadBarMessage, imgElement, mainCardLink;
let userSelectionObject = {}

//BRENDAN: This file is created and served on rackFormWayne.liquid. It renders by calling it in the theme.liquid file.
//adding the domcontentloaded function around all event Listeners
document.addEventListener('DOMContentLoaded', function () {
    bikeValue = document.getElementById('bikeNumberOutput1').innerText;
    const mtb = document.getElementById('mtb');
    const road = document.getElementById('road');
    const electric = document.getElementById('electric');
    const fat = document.getElementById('fatTire');
    const garageUse = document.getElementById('garageUse')
    const vehicleType = document.getElementById('vehicleType');
    const totalMTB = document.getElementById('totalMTB');
    const totalRoad = document.getElementById('totalRoad');
    const totalElectric = document.getElementById('totalElectric');
    const totalFat = document.getElementById('totalFat');
    const totalChild = document.getElementById('totalChild');

    vehicleTypeMessage = document.getElementById('vehicleTypeMessage');
    roadBarMessage = document.getElementById('roadBarMessage');
    const roadMessage = document.getElementById('roadMessage');

    const garageMessage = document.getElementById('garageMessage');
    // Get the reference to the image element
    imgElement = document.getElementById('mainCardImage');
    mainCardElement = document.getElementById('mainCardLink');
    // const garage = document.getElementById('garageUse');
    button1 = document.getElementById('button1')
    button2 = document.getElementById('button2')
    button3 = document.getElementById('button3')
    button4 = document.getElementById('button4')
    button5 = document.getElementById('button5')
    button6 = document.getElementById('button6')
    button7 = document.getElementById('button7')

    mtb.addEventListener('input', () => {
        checkboxUpdate(mtb, totalMTB, mtbMessage, 'mtb')
    })

    road.addEventListener('input', () => {
        checkboxUpdate(road, totalRoad, roadMessage, 'road')
    })

    electric.addEventListener('input', () => {
        checkboxUpdate(electric, totalElectric, elecMessage, 'elec')
    })

    fat.addEventListener('input', () => {
        checkboxUpdate(fat, totalFat, fatMessage, 'fat')
    })

    child.addEventListener('input', () => {
        checkboxUpdate(child, totalChild, childMessage, 'child')
    })

    vehicleType.addEventListener('input', function () {
        updateButtonBarMaxAttribute()
    });

    garageUse.addEventListener('input', function () {
        console.log('garage Message', garageMessage)
        if (garageUse.value === 'true') {
            garageMessage.removeAttribute('hidden')
        } else {
            garageMessage.setAttribute('hidden', '')
        }
    })

});

function getRackTypeByNumBikes(numBikes) {
    for (const key in rackType) {
        if (rackType[key].tags === numBikes) {
            return rackType[key];
        }
    }
    // Return null or throw an error if no match is found
    return null;
}

function createButton(id, label) {
    const button = document.createElement('button');
    button.className = 'numButton';
    button.id = id;
    button.type = 'button';
    button.textContent = label;
    // button.onclick = onClick;
    return button;
}

function createButtons(container, count, type, roadNormal) {
// console.log('count', count)
    for (let i = 1; i <= count; i++) {
        const id = `${type}B${i}`;
        const button = createButton(id, i);

        //check if button being created matches a button that is selected
        if(type in userSelectionObject) {
            
            //if the button has been selected add the appropriate css
            if (i === userSelectionObject[type]){
                button.classList.add("clicked");
            }
        }
        
        // Add "firstButton" class to the first button
        if (i === 1) {
            button.classList.add('firstButton');
        }

        // Add "lastButton" class to the last button
        if (i === count) {
            button.classList.add('lastButton');
        }

        // //make Yellow button if warning
        if (type===bikeTypesEnum.ROAD && i > roadNormal) {
            addWarningEventListiner(button)
        }

        // Add click event listener with the clickHandler
        button.addEventListener('click', () => clickHandler(type, i, button));

        container.appendChild(button);
    }
}

function getTotalNumberOfBikesSelected() {
    let total = 0
    for (let type in userSelectionObject) {
        total += userSelectionObject[type]
    }
    return total
}

function clickHandler(type, value) {

    Object.keys(userSelectionObject).forEach(eachType => {
        if (eachType === type) {
                delete userSelectionObject[type]
                document.getElementById(`${eachType}Output`).textContent = value
            }
        updateMaxButtonsAll();
        updateOptionalRackHTML();
    })

    // Size of bike rack the user selected 
    const bikeValue = Number(bikeNumberOutput1.textContent) < 3 ? 3 : Number(bikeNumberOutput1.textContent);
    // Check the rules before proceeding
    const errorMessage = isSelectionValidBasedOffRackRules(type, value, userSelectionObject, bikeValue)
    const warningElem = document.getElementById('error')

    if (errorMessage) {
        console.log(`ErrorMessage: ${errorMessage}`)
        warningElem.innerHTML = errorMessage;
        return errorMessage;
    } else {
        warningElem.innerHTML = '';
    }

    // sets the value of bikes selected. This is shown above the bike selector button area
    const outputElement = document.getElementById(`${type}Output`);
    outputElement.textContent = value;

    //set the clicked button to be red
    const clickedButtonElem = document.getElementById(`${type}B${value}`)
    clickedButtonElem.classList.add("clicked");

    let numBikes = Number(bikeNumberOutput1.textContent) < 3 ? 3 : Number(bikeNumberOutput1.textContent);
    const rackTypeEnum = getRackTypeByNumBikes(numBikes);
  
    if (type===bikeTypesEnum.ROAD && value > rackTypeEnum.roadNormal) {
        roadBarMessage.style.display = 'block';
        // addWarningEventListiner(button)
    } else {
        roadBarMessage.style.display = 'none';
    }

    // Keeps track of the user's selection bike type and the number they selected
    userSelectionObject[type]=value;
    
    updateOptionalRackHTML();
    updateMaxButtonsAll();
}


const rackRules = [
    { bikeNum: 7, bikeCheck: 'mtb', bikeCheckNum: 5, otherType: bikeTypesEnum.ROAD, buttonValue: 2 },
    { bikeNum: 7, bikeCheck: 'mtb', bikeCheckNum: 4, otherType: bikeTypesEnum.ROAD, buttonValue: 3 },
    { bikeNum: 7, bikeCheck: 'mtb', bikeCheckNum: 3, otherType: bikeTypesEnum.ROAD, buttonValue: 3 },
    // { bikeNum: 7, bikeCheck: 'mtb', bikeCheckNum: 2, otherType: bikeTypesEnum.ROAD, buttonValue: 3 },
    // { bikeNum: 7, bikeCheck: 'mtb', bikeCheckNum: 2, otherType: bikeTypesEnum.ROAD, buttonValue: 4 },
    { bikeNum: 6, bikeCheck: 'mtb', bikeCheckNum: 4, otherType: bikeTypesEnum.ROAD, buttonValue: 2 },
    { bikeNum: 6, bikeCheck: 'mtb', bikeCheckNum: 3, otherType: bikeTypesEnum.ROAD, buttonValue: 3 },
    { bikeNum: 6, bikeCheck: 'mtb', bikeCheckNum: 2, otherType: bikeTypesEnum.ROAD, buttonValue: 3 },
    { bikeNum: 5, bikeCheck: 'mtb', bikeCheckNum: 3, otherType: bikeTypesEnum.ROAD, buttonValue: 2 },
    { bikeNum: 5, bikeCheck: 'mtb', bikeCheckNum: 2, otherType: bikeTypesEnum.ROAD, buttonValue: 3 },
];

  const checkAllConditions = (bikeValue, type, buttonNum, button) => {
    rackRules.forEach((condition) => {
      const { bikeNum, otherType, buttonValue, bikeCheck, bikeCheckNum } = condition;

      if (
        bikeValue === bikeNum &&
        userSelectionObject[bikeCheck] === bikeCheckNum &&
        type === otherType &&
        buttonValue === buttonNum
      ) {
        addWarningEventListiner(button);
      }
    });
  };

function addWarningEventListiner(button) {
    button.classList.add("warning");
    button.addEventListener('mouseover', () => {      
        // Display the tooltip
        roadBarMessage.style.display = 'block'; 
    })
    button.addEventListener('mouseout', () => {
        // Hide the tooltip when the mouse leaves the button
        const roadValueElem = document.getElementById('roadOutput')
        console.log('element', roadValueElem.textContent)
        if (roadValueElem.textContent == 0) {
            roadBarMessage.style.display = 'none';
        } else {
            roadBarMessage.style.display = 'block';
        }
    })
}

function getPropertyValue(enumName, propertyName) {
    return rackType[enumName] ? rackType[enumName][propertyName] : undefined;
}

function updateMaxButtonsAll() {
    let numBikes = Number(bikeNumberOutput1.textContent) < 3 ? 3 : Number(bikeNumberOutput1.textContent);
    const bikeTypes = Object.values(bikeTypesEnum)
    const rackTypeEnum = getRackTypeByNumBikes(numBikes);
    const totalNumBikesSelected = getTotalNumberOfBikesSelected();

    // special case where the 5 rack bike needs to use the 5X max bike rules
    if (numBikes === 5) {
        rackTypeEnum.fat = rackType.EIGHT.fat;
    }

    for (const type of bikeTypes) {
        const container = document.querySelector(`.button-container[data-type=${type}]`);

        if (!userSelectionObject.hasOwnProperty(type)) {
            container.innerHTML = ''; // Clear existing buttons
            
            const bikeNumToShow = rackTypeEnum.maxNumBikes - totalNumBikesSelected > rackTypeEnum[type] 
                    ? rackTypeEnum[type] 
                    : rackTypeEnum.maxNumBikes - totalNumBikesSelected;

            createButtons(container, bikeNumToShow, type, rackTypeEnum.roadNormal);
    
        } // else {
        //     const bikesLeft = rackTypeEnum.maxNumBikes - totalNumBikesSelected
        //     if (bikesLeft > bikeTypesEnum[type]) {
        //         container.innerHTML = ''; // Clear existing buttons
        //         createButtons(container, userSelectionObject[type], type, rackTypeEnum.roadNormal);
        //     } else {
        //         container.innerHTML = ''; // Clear existing buttons
        //         createButtons(container, bikesLeft + userSelectionObject[type], type, rackTypeEnum.roadNormal);
        //     }
        // }
    }
}

function updateButton(button, value) {

    //clear the user selections in biketypes if new totalbike num is selected
    Object.keys(userSelectionObject).forEach(type => {
        document.getElementById(`${type}Output`).textContent = 0
    })
    userSelectionObject = {}

    // Reset the previous button's style
    if (previousButton) {

        previousButton.style.backgroundColor = '';
        previousButton.style.color = '';
    }

    // Change the background color of the clicked button
    button.style.backgroundColor = '#a41414';
    button.style.color = '#fff';

    // Update the output to show the value clicked by the user
    document.getElementById('bikeNumberOutput1').textContent = value;

    previousButton = button;

    updateMaxButtonsAll();
    updateOptionalRackHTML();
}

function isEmpty(obj) {
    return Object.entries(obj).length === 0;
}

function isSelectionValidBasedOffRackRules(type, value, userSelectionObject, bikeValue) {
    // Doesn't matter the rack size, elec bikes not allowed to go over 4 with any other bikes
    if (type === 'elec' && !isEmpty(userSelectionObject)) {
        if (value === 4) {
            return 'Four electric bikes is the max weight this rack can hold';
        }
        // Not sure what the other values can be, but know 4 is NOT allowed with any other bike
    }
    // If the user is trying to select any other bikes and has selected 4 electric bikes, give them a warning
    if (userSelectionObject.elec === 4) {
        return 'You cannot add any other bikes to your selection'
    }

    // Fat bikes take different values per rack size
    const rack = getRackTypeByNumBikes(bikeValue)
    if (type === 'fat' && !isEmpty(userSelectionObject)) {
        if (value === rack.fat) {
            return `You are only allowed to select ${rack.fat} number of fat bikes for this size rack`;
        }
    }
    // If the user is trying to select any other bikes and has selected X number of fat bikes, give them a warning
    if (userSelectionObject.fat === rack.fat) {
        return 'You cannot add any other bikes to your selection.  You have reached the max number of fat bikes for this bike rack'
    }
}

function checkboxUpdate(checkbox, totalElement, messageElement, property) {
    if (checkbox.checked) {
        totalElement.removeAttribute('hidden'); // Remove the hidden attribute
        messageElement.removeAttribute('hidden')
    } else {
        totalElement.setAttribute('hidden', ''); // Add the hidden attribute
        messageElement.setAttribute('hidden', '')
        delete userSelectionObject[property]
        const outputElement = document.getElementById(`${property}Output`);
        outputElement.textContent = 0;
        updateMaxButtonsAll();
        updateOptionalRackHTML();
    }
}

function updateOptionalRackHTML() {
    // update the optionalRacks shown
    const bikeValue = Number(bikeNumberOutput1.textContent) < 3 ? 3 : Number(bikeNumberOutput1.textContent);
    const data = fetchRecomendedProduct(bikeValue);
    productList.innerHTML = generateProductListHTML(data);
}

function fetchRecomendedProduct(bikeValue){
    let recomendedProduct
    const allNumSelectBikes = getTotalNumberOfBikesSelected();
    let recommendedProductNum;
    if(bikeValue<3) {
        bikeValue = 3;
    }
    
    if((parseInt(userSelectionObject.road) > 2 && allNumSelectBikes < 6) || (bikeValue === 5 && parseInt(userSelectionObject.fat) > 3)){
        recomendedProduct = productsData.filter(product => parseInt(product.tags) === 8)[0];
        recommendedProductNum = 8;
    } else {
        recomendedProduct = productsData.filter(product => parseInt(product.tags) === bikeValue)[0];
        recommendedProductNum = bikeValue;
    }
    // Update the card attributes
    imgElement.src = `${recomendedProduct.img}`;
    imgElement.alt = `${recomendedProduct.title}`;
    mainCardElement.href = `${recomendedProduct.href}`;
    mainCardElement.innerHTML = `${recomendedProduct.title}`;

    const optionalProducts = findCompatibleRackTypes(userSelectionObject, recommendedProductNum, bikeValue);
    let optionalProduct = productsData.filter(product => optionalProducts.includes(parseInt(product.tags)));

    return optionalProduct
}

function findCompatibleRackTypes(bikeCounts, recommendedProductNum, bikeValue) {
    const compatibleRackTypes = [];

    for (const type in rackType) {
        if (Object.prototype.hasOwnProperty.call(rackType, type)) {
            const typeValues = rackType[type];

            if (typeValues.tags === recommendedProductNum) {
                continue; // Skip if tags match recommendedProductNum
            }

            let isCompatible = true;

            if (Object.keys(bikeCounts).length === 0) {
                isCompatible = bikeValue <= typeValues.maxNumBikes;
            } else {
                if (typeValues.maxNumBikes < getTotalNumberOfBikesSelected()) {
                    isCompatible = false;
                } else {
                    for (const bikeType in bikeCounts) {
                        if (Object.prototype.hasOwnProperty.call(bikeCounts, bikeType) && typeValues[bikeType]) {
                            if (bikeCounts[bikeType] > typeValues[bikeType]) {
                                isCompatible = false;
                                break;
                            }
                        }
                    }
                }
            }

            if (isCompatible) {
                compatibleRackTypes.push(typeValues.tags);
            }
        }
    }

    return compatibleRackTypes;
}

function updateButtonBarMaxAttribute() {
    const numBikes = bikeNumberOutput1.textContent;
    prevButtonNum = numBikes;

    if (vehicleType.value === '1') {
        // If vehicleType is "Small," set the max attribute of the slider to 6
        if (bikeNumberOutput1.textContent === '7') {
            prevButtonNum = '7'
            bikeNumberOutput1.textContent = '6';
            vehicleTypeMessage.removeAttribute('hidden')
            updateButton(button6, '6');
        }
        // Add the 'hidden' attribute to the button with class "lastButton"
        button7.setAttribute('hidden', '');
        button7.classList.add('hidden')
        button7.style.backgroundColor = '';
        button6.setAttribute('class', 'lastButton numButton');
    } else {
        button7.removeAttribute('hidden');
        button7.setAttribute('class', 'numButton lastButton');
        button7.classList.remove('hidden')
        button6.setAttribute('class', 'numButton');
        vehicleTypeMessage.setAttribute('hidden', '')
    }
}

// Function to generate the product list HTML based on fetched data
function generateProductListHTML(productsData) {
    let productListHTML = '';
    let i = 0
    productsData.forEach(product => {
        productListHTML += `
            <div class="optionSection">
                <div class="cardNborder" >
                    <div>
                      <div class="cardHead">
                        <h3>Optional Rack</h3>
                        <h4>
                            <a href="${product.href}" style="background-color: #a41414; color: white; padding: 10px 10px; text-align: center; text-decoration: none; display: inline-block;">${product.title}</a>
                        </h4>
                      </div>
                        <img class="cardImg" src="${product.img}" alt="${product.title}">
                    </div>
                </div>
            </div>`;
    });
 
    return productListHTML;
}